import { FC } from 'react';
import { RoleEntryButtons, GenesisRole } from '../RoleEntryButtons';
import { useGamenics, GamenicsEvent } from '../../hooks/useGamenics';
import { Icon } from '../icons/Icon';
import { assetLayerStyle } from '../../hooks/useSiteAssets';

/**
 * TownHero — 街の門（モックC v2）
 *
 * - 画像スロット: heroBg（Admin登録・未登録時は既定の紫グラデ）
 * - 3役対等のエントリー（GEN-01）＋ 主CTA「街に入る」1つ（調停原則4: 意思決定4以内）
 * - パルス誘導は主CTAのみ（調停原則2: 1画面1箇所、reduced-motion時は静的リング）
 * - 2026-08-14: 3役ボタンは「いきなり起点投稿」から**各町への入口**に変更（オーナー決定）。
 *   初見でいきなり共作を促すのはハードルが高い — まず自分の役割の町へ。
 *   起点投稿の導線は各街区カード・作品一覧側に残っている。
 */
export const TownHero: FC<{
    heroBg: string | null;
    /** 役割を選んだら、その役割の町（サロン/トキワ荘/ステージ）へ移動する */
    onSelectRole: (role: GenesisRole) => void;
}> = ({ heroBg, onSelectRole }) => {
    const { playSound } = useGamenics();

    const enterTown = () => {
        playSound(GamenicsEvent.TAP_CONFIRM);
        document.getElementById('salon')?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <section className="asset-hero text-center px-6 pt-16 pb-14" style={assetLayerStyle(heroBg)}>
            <div className="max-w-3xl mx-auto">
                <p className="font-display font-bold tracking-[0.18em] text-pop text-sm mb-5">STORY ・ ART ・ VOICE</p>
                <h1 className="font-display font-black text-ink leading-[1.25] mb-5 text-[clamp(28px,4.5vw,44px)]">
                    <span className="text-role-script-text">書き手</span>と
                    <span className="text-role-illustration-text">描き手</span>と
                    <span className="text-role-voice-text">演じ手</span>が暮らす街。
                </h1>
                <p className="text-ink-2 text-base md:text-lg leading-relaxed max-w-xl mx-auto mb-8">
                    ANOKOEは作品を「投稿して終わる」場所ではなく、3つの役割が集まり、磨き合い、
                    そこから三位一体の作品が生まれていく街です。
                </p>

                {/* 3役対等のエントリー（書く・描く・演じる）→ 各町へ */}
                <RoleEntryButtons onSelect={onSelectRole} />

                {/* 主CTA（この画面で唯一のパルス誘導。矢印アイコンは静的代替の要件） */}
                <div className="mt-5">
                    <button className="btn btn-primary cta-pulse" onClick={enterTown}>
                        街に入る <Icon name="arrow-right" size={16} />
                    </button>
                </div>
            </div>
        </section>
    );
};
